import * as React from 'react'

// Styles
import './RadioGroup.scss'

// Components
import { Field } from '@metrisk/react_metrisk-components'

const RadioGroup = ({ value, options, onChange }: any) => (
  <div className={'radio-group'}>
    {options.map((x: any) => (
      <Field
        key={`field-${x.label}`}
        id={x.label}
        name={x.label}
        label={x.label}
        type={'radio'}
        value={value === x.value}
        onChange={() => onChange(x.value)}
      />
    ))}
  </div>
)

export default RadioGroup
